import { useFeatureFlagQuery } from 'remote-state/featureFlagsHooks';
import { FEATURE_FLAGS_KEYS } from 'constants/featureFlags';
import { ReactComponent as NewSysaidLogo } from 'images/icons/new_sysaid_logo.svg';
import { ReactComponent as NewCollapsedSysAidLogo } from 'images/icons/new_logo_collapsed.svg';
import sysAidLogo from 'images/photos/sysaid_logo.png';
import collapsedSysAidLogo from 'images/photos/logo_collapsed.png';
import { StyledSysAidLogo, StyledSvgLogo } from './style';
import { StyledCustomerLogoFooterWrapper } from '../navHeader/style';

const NavFooter = ({ expanded }) => {
  const { data: isNewSysAidLogoEnabled, isFetched } = useFeatureFlagQuery({
    flagKey: FEATURE_FLAGS_KEYS.NEW_SYSAID_LOGO_IN_SPACES,
    defaultValue: false,
  });

  const renderLogo = () => {
    if (isNewSysAidLogoEnabled) {
      return expanded ? (
        <StyledSvgLogo as={NewSysaidLogo} className="sysaid-logo" data-testid="new-sysaid-logo" />
      ) : (
        <StyledSvgLogo as={NewCollapsedSysAidLogo} className="sysaid-logo" data-testid="new-collapsed-logo" />
      );
    }
    return isFetched ? (
      <StyledSysAidLogo
        expanded={expanded}
        alt="sysaid-logo"
        src={expanded ? sysAidLogo : collapsedSysAidLogo}
        className="sysaid-logo"
        data-testid="old-sysaid-logo"
      />
    ) : null;
  };

  return <StyledCustomerLogoFooterWrapper>{renderLogo()}</StyledCustomerLogoFooterWrapper>;
};

export default NavFooter;
